import './App.less';
import ContactUs from './Model/ConatctUs';
import Description from './Model/Description';
import Footer from './Model/Footer';
import Header from './Model/Header';
import Services from './Model/Service';
import Testimonials from './Model/Testimonials';
import VideoSection from './Model/VideoSection';
import ImageSlider from './Model/ImageSlider';
import WhyChooseUs from './Model/WhyChooseUs';
import logo from './logo.jpeg'
import contactPhoto from "./contact-us.jpeg";

import { useNavigate } from 'react-router-dom';

function HomePage() {
  const navigate = useNavigate();
  const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems: [
      { name: 'Home', link: '/', onClick: () => navigate('/') },
      { name: 'About', link: '/aboutus', onClick: () => navigate('/aboutus') },
      {
        name: 'Gallery',
        link: '/services',
        onClick: () => navigate('/services'), 
        children: [
          {
            name: 'Custom Build',
            link: '/gallery/custom-built',
            onClick: () => navigate('/town')
          },
          {
            name: 'Home Designs',
            link: '/gallery/home-design',
            onClick: () =>  navigate('/custom')
          },
          {
            name: 'Knock Down Rebuild',
            link: '/gallery/knockdown-rebuilt',
            onClick: () =>  navigate('/know')
          },
          {
            name: 'Current Projects',
            link: '/gallery/townhouses',
            onClick: () =>  navigate('/gallery')
          }, 
          // {
          //   name: 'Current Projects',
          //   link: '/gallery/townhouses',
          //   onClick: () =>  navigate('/town')
          // }
        ]
      },
      { name: 'Contact', link: '/contact', onClick: () => navigate('/contact') }
    ]
  };

const Brand = "Aspire Homes"
return (
  <>
    <Header {...headerConfig} />
    {/* <VideoSection id="video" /> */}
    <ImageSlider id="video"/>
    <Description id="about" />
    <Services id="services" />
    <WhyChooseUs id="why" />
    <Testimonials id="testimonials" />
    <ContactUs
        id="contact"
        contactPhoto={contactPhoto}
      />
    <Footer />
  </>
);

};


export default HomePage;
